import {
  Button,
  Checkbox,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {submitAgentBranchFee, updateAgentBranchFee} from "../../services/agent_branch_fee/agent_branch_fee";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {Toaster} from "../../helper/Toaster";
import Validator from "../../helper/validator/Validator";
import {ValidatorProvider} from "../../helper/validator/ValidatorContext";
import {checkAll} from "../../helper/validator/Check";
import {toast} from "react-toastify";

export function AgentBranchFeeForm({agentBranchFee, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {

  const handleOpen = () => setOpen(!open);

  const [consultationId, setConsultationId] = useState()
  const [serviceId, setServiceId] = useState()
  const [agentBranchId, setAgentBranchId] = useState()
  const [fieldTitle, setFieldTitle] = useState()
  const [branchId, setBranchId] = useState()
  const [branchTitle, setBranchTitle] = useState()
  const [consultationType, setConsultationType] = useState()
  const [serviceType, setServiceType] = useState()
  const [consultationPrice, setConsultationPrice] = useState(null)
  const [servicePrice, setServicePrice] = useState()
  const [consensual, setConsensual] = useState()
  const [maxPrice, setMaxPrice] = useState(null)
  const [minPrice, setMinPrice] = useState(null)
  const [sideCost, setSideCost] = useState()
  const [sideCostDescription, setSideCostDescription] = useState("")
  const [period, setPeriod] = useState(false)
  const [day, setDay] = useState()
  const [minDay, setMinDay] = useState()
  const [maxDay, setMaxDay] = useState()
  const [consultationStatus, setConsultationStatus] = useState()
  const [serviceStatus, setServiceStatus] = useState()
  const [consultationCommission, setConsultationCommission] = useState()
  const [serviceCommission, setServiceCommission] = useState()

  const [consultationEarn, setConsultationEarn] = useState(null)
  const [serviceEarn, setServiceEarn] = useState()
  const [minEarn, setMinEarn] = useState()
  const [maxEarn, setMaxEarn] = useState()

  useEffect(() => {
    setConsultationId((agentBranchFee && agentBranchFee.consultation_id) || 0)
    setServiceId((agentBranchFee && agentBranchFee.service_id) || 0)
    setAgentBranchId((agentBranchFee && agentBranchFee.agent_branch_id) || null)
    setFieldTitle((agentBranchFee && agentBranchFee.field_title) || null)
    setBranchId((agentBranchFee && agentBranchFee.branch_id) || null)
    setBranchTitle((agentBranchFee && agentBranchFee.branch_title) || null)
    setConsultationType((agentBranchFee && agentBranchFee.consultation_type) || null)
    setServiceType((agentBranchFee && agentBranchFee.service_type) || null)
    setConsultationPrice((agentBranchFee && agentBranchFee.consultation_price) || null)
    setConsultationEarn(((agentBranchFee && agentBranchFee.consultation_price && (parseInt(consultationPrice) * (100 - parseInt(consultationCommission)) / 100)) || 0))
    setServicePrice((agentBranchFee && agentBranchFee.service_price) || null)
    setConsensual((agentBranchFee && agentBranchFee.consensual) || false)
    setMaxPrice((agentBranchFee && agentBranchFee.max_price) || null)
    setMinPrice((agentBranchFee && agentBranchFee.min_price) || null)
    setSideCost((agentBranchFee && agentBranchFee.side_cost) || false)
    setSideCostDescription((agentBranchFee && agentBranchFee.side_cost_description) || "")
    setPeriod((agentBranchFee && agentBranchFee.period) || false)
    setDay((agentBranchFee && agentBranchFee.day) || null)
    setMinDay((agentBranchFee && agentBranchFee.min_day) || null)
    setMaxDay((agentBranchFee && agentBranchFee.max_day) || null)
    setConsultationStatus((agentBranchFee && agentBranchFee.consultation_status) || 'disable')
    setServiceStatus((agentBranchFee && agentBranchFee.service_status) || 'disable');
    setConsultationCommission((agentBranchFee && agentBranchFee.consultation_commission) || null);
    setServiceCommission((agentBranchFee && agentBranchFee.service_commission) || null);
  }, [agentBranchFee]);

  const save = async () => {
    let err = false
    
    // Business logic validations
    if (serviceStatus === 'enable' && consensual && maxPrice && minPrice && parseInt(maxPrice) <= parseInt(minPrice)) {
      toast.error("حداکثر هزینه خدمات نمی‌تواند کمتر یا برابر حداقل هزینه خدمات باشد!")
      err = true
    }
    if (serviceStatus === 'enable' && !consensual && !servicePrice) {
      toast.error("وارد کردن هزینه خدمات الزامیست!")
      err = true
    }
    if (serviceStatus === 'enable' && consensual && (!minPrice || !maxPrice)) {
      toast.error("وارد کردن حداقل و حداکثر هزینه خدمات الزامیست!")
      err = true
    }

    if (serviceStatus === 'enable' && !period && !day) {
      toast.error("وارد کردن تعداد روز انجام کار الزامیست!")
      err = true
    }
    // When period is enabled, require both minDay and maxDay
    if (serviceStatus === 'enable' && period && (!minDay || !maxDay)) {
      toast.error("وارد کردن حداقل و حداکثر دوره انجام خدمات الزامیست!")
      err = true
    }
    // Only compare when both values are present (avoid NaN comparisons)
    if (serviceStatus === 'enable' && period && minDay && maxDay && (parseInt(maxDay) <= parseInt(minDay))) {
      toast.error("حداکثر دوره انجام خدمات نمی‌تواند کمتر از حداقل دوره باشد!")
      err = true
    }
    
    if (err) {
      return
    }
    
    // Check form validations
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید")
      return
    }

    const data = {
      agent_branch_id: agentBranchId,
      consultation_price: parseInt(consultationPrice) || 0,
      service_price: parseInt(servicePrice) || 0,
      consensual: consensual,
      max_price: parseInt(maxPrice) || 0,
      min_price: parseInt(minPrice) || 0,
      side_cost: sideCost,
      side_cost_description: sideCostDescription,
      period: period,
      day: parseInt(day) || 0,
      min_day: parseInt(minDay) || 0,
      max_day: parseInt(maxDay) || 0,
      consultation_status: consultationStatus,
      service_status: serviceStatus,
    };

    if (consensual) {
      data.service_price = 0
    }
    if (!sideCost) {
      data.side_cost_description = ""
    }

    let result;

    if (consultationId === 0 && serviceId === 0) {
      result = await submitAgentBranchFee(data)
    } else {
      data.consultation_id = consultationId
      data.service_id = serviceId
      result = await updateAgentBranchFee(data)
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  useEffect(() => {
    setConsultationEarn(parseInt(consultationPrice) * (100 - parseInt(consultationCommission)) / 100)
  }, [consultationCommission, consultationPrice]);

  useEffect(() => {
    setServiceEarn(parseInt(servicePrice) * (100 - parseInt(serviceCommission)) / 100)
  }, [serviceCommission, servicePrice]);

  useEffect(() => {
    setMinEarn(parseInt(minPrice) * (100 - parseInt(serviceCommission)) / 100)
  }, [serviceCommission, minPrice]);

  useEffect(() => {
    setMaxEarn(parseInt(maxPrice) * (100 - parseInt(serviceCommission)) / 100)
  }, [serviceCommission, maxPrice]);

  const handleConsensualChecked = () => {
    setConsensual(!consensual);
  };

  const handleConsultationChecked = () => {
    consultationStatus === 'enable' ?
      setConsultationStatus('disable') :
      setConsultationStatus('enable')
  }

  const handleServiceChecked = () => {
    serviceStatus === 'enable' ?
      setServiceStatus('disable') :
      setServiceStatus('enable')
  }

  const handlePeriodChecked = () => {
    setPeriod(!period)
  }

  // Helper function to add asterisk to required fields
  const getLabelWithAsterisk = (labelKey, isRequired = false) => {
    const label = Dict(labelKey);
    return isRequired ? `${label} *` : label;
  };

  return (
    <ValidatorProvider>
      <>
        <Dialog open={open} handler={handleOpen}
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>{"تعیین تعرفه " + fieldTitle + " - " + branchTitle}</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll"
                      style={{overflowY: 'auto', maxHeight: '80vh', minHeight: '80vh'}}>

            <Checkbox
              checked={consultationStatus === 'enable'}
              onClick={handleConsultationChecked}
              label={
                <Typography color="blue-gray" className="flex font-medium" variant="h4">
                  تعیین قیمت مشاوره
                </Typography>
              }

            />
            {(consultationStatus === 'enable') &&
              <div className="grid grid-cols-1 md:grid-cols-2 xxl:grid-cols-3">
                <div className="flex flex-col w-full mb-4">
                  <Input className="flex flex-row"
                         variant="standard"
                         value={consultationPrice || ''}
                         type="number"
                         label={getLabelWithAsterisk('consultation_price', true)}
                         placeholder={Dict('consultation_price')}
                         onChange={(e) => {
                           setConsultationPrice(e.target.value)
                         }}
                         onBlur={(e) => {
                           const value = parseInt(e.target.value);
                           if (!isNaN(value)) {
                             setConsultationPrice(Math.ceil(value / 50000) * 50000)
                           }
                         }}
                  />
                  <Validator state={consultationStatus === 'enable' ? consultationPrice : ''} rules="required|num" />
                  <Typography className="text-red-500 text-sm mt-1">
                    *مبلغ وارد شده باید برمبنای ضریب 50000 ریال باشد.
                  </Typography>
                </div>
                {!isNaN(consultationEarn) &&
                  <Typography color="blue-gray" className="flex w-full mb-4">
                    {persianNumberFormat(consultationEarn, true) + " " + "ریال سهم شما به ازای دقیقه"}
                  </Typography>
                }
              </ div>
            }

            <Checkbox
              checked={serviceStatus === 'enable'}
              onClick={handleServiceChecked}
              label={
                <Typography color="blue-gray" className="flex font-medium" variant="h4">
                  تعیین قیمت خدمات
                </Typography>
              }

            />

            {(serviceStatus === 'enable') &&
              <>
                <Checkbox className=""
                          checked={consensual}
                          onClick={handleConsensualChecked}
                          label={
                            <Typography color="blue-gray" className="flex font-medium">
                              قیمت توافقی (اگر خدمات شما قیمت ثابت ندارد و بستگی به عوامل مختلفی دارد این گزینه را فعال
                              کنید)
                            </Typography>
                          }

                />
                {!consensual &&
                  <div className="grid grid-cols-1 md:grid-cols-2 xxl:grid-cols-3">
                    <div className="flex flex-col mb-4">
                      <Input className="flex flex-row"
                             variant="standard"
                             value={servicePrice || ''}
                             type="number"
                             label={getLabelWithAsterisk('service_price', true)}
                             placeholder={Dict('service_price')}
                             onChange={(e) => {
                               setServicePrice(e.target.value)
                             }}
                             onBlur={(e) => {
                               const value = parseInt(e.target.value);
                               if (!isNaN(value)) {
                                 setServicePrice(Math.ceil(value / 50000) * 50000)
                               }
                             }}
                             disabled={consensual}
                      />
                      <Validator state={serviceStatus === 'enable' && !consensual ? servicePrice : ''} rules="required|num" />
                    </div>
                    {!isNaN(serviceEarn) &&
                      <Typography color="blue-gray" className="flex font-medium mb-4">
                        {persianNumberFormat(serviceEarn, true) + " " + "ریال سهم شما از خدمات"}
                      </Typography>
                    }
                  </div>
                }

                {consensual &&
                  <div className="grid grid-cols-1 md:grid-cols-2 xxl:grid-cols-3">
                    <div className="mb-4 md:ml-3">
                      <Input className="flex flex-row"
                             variant="standard"
                             value={minPrice || ''}
                             type="number"
                             label={getLabelWithAsterisk('min_service_price', true)}
                             placeholder={Dict('min_service_price')}
                             onChange={(e) => {
                               setMinPrice(e.target.value)
                             }}
                             onBlur={(e) => {
                               const value = parseInt(e.target.value);
                               if (!isNaN(value)) {
                                 setMinPrice(Math.ceil(value / 50000) * 50000)
                               }
                             }}
                      />
                      <Validator state={serviceStatus === 'enable' && consensual ? minPrice : ''} rules="required|num" />
                    </div>

                    <div className="mb-4 md:mr-3">
                      <Input variant="standard"
                             value={maxPrice || ''}
                             type="number"
                             label={getLabelWithAsterisk('max_service_price', true)}
                             placeholder={Dict('max_service_price')}
                             onChange={(e) => {
                               setMaxPrice(e.target.value)
                             }}
                             onBlur={(e) => {
                               const value = parseInt(e.target.value);
                               if (!isNaN(value)) {
                                 setMaxPrice(Math.ceil(value / 50000) * 50000)
                               }
                             }}
                      />
                      <Validator state={serviceStatus === 'enable' && consensual ? maxPrice : ''} rules="required|num" />
                    </div>
                    {(minPrice && maxPrice) &&
                      <Typography color="blue-gray" className="flex w-full font-medium mb-4">
                        {"سهم شما از " + persianNumberFormat(minEarn, true) + " تا " + persianNumberFormat(maxEarn, true) + " ریال "}
                      </Typography>
                    }

                  </div>
                }

                {consensual === true &&
                  <Checkbox
                    checked={sideCost}
                    onClick={() => {
                      setSideCost(!sideCost)
                    }}
                    label={
                      <Typography color="blue-gray" className="flex font-medium">
                        هزینه های جانبی و دولتی (اگر انجام خدمات به غیر از هزینه های حق الزحمه، شامل هزینه های دولتی و
                        جانبی می
                        باشد، این گزینه را فعال کنید
                        )
                      </Typography>
                    }
                  />
                }

                {sideCost &&
                  <div className="mb-4 flex flex-col">
                    <Textarea className="flex flex-row"
                              variant="standard"
                              value={sideCostDescription}
                              label={Dict('side_cost_description')}
                              placeholder={Dict('side_cost_description')}
                              onChange={(e) => {
                                setSideCostDescription(e.target.value)
                              }}
                    />
                    <div className="flex flex-row">
                      <Validator state={sideCost ? sideCostDescription : ''} rules="alphanumeric" />
                    </div>
                  </div>
                }
                <Checkbox
                  checked={period}
                  onClick={handlePeriodChecked}
                  label={
                    <Typography color="blue-gray" className="flex font-medium">
                      تعیین بازه زمانی خدمات (اگر مدت انجام خدمات به عوامل مختلفی بسته دارد و زمان مشخصی نمی توان ارائه
                      کرد،بهتر است از بازه زمانی بر اساس روز های کاری استفاده نمائید و این گزینه را فعال نمائید.
                      )
                    </Typography>
                  }
                />
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xxl:grid-cols-3">
                  {!period &&
                    <div className="mb-4">
                      <Input variant="standard"
                             value={day || ''}
                             type="number"
                             label={getLabelWithAsterisk('service_day', true)}
                             placeholder={Dict('service_day')}
                             onChange={(e) => {
                               setDay(e.target.value)
                             }}
                      />
                      <Validator state={serviceStatus === 'enable' && !period ? day : ''} rules="required|num" />
                    </div>
                  }
                  {period &&
                    <>
                      <div className="mb-4">
                        <Input variant="standard"
                               value={minDay || ''}
                               type="number"
                               label={getLabelWithAsterisk('min_service_day', true)}
                               placeholder={Dict('min_service_day')}
                               onChange={(e) => {
                                 setMinDay(e.target.value)
                               }}
                        />
                        <Validator state={serviceStatus === 'enable' && period ? minDay : ''} rules="required|num" />
                      </div>

                      <div className="mb-4">
                        <Input variant="standard"
                               value={maxDay || ''}
                               type="number"
                               label={getLabelWithAsterisk('max_service_day', true)}
                               placeholder={Dict('max_service_day')}
                               onChange={(e) => {
                                 setMaxDay(e.target.value)
                               }}
                        />
                        <Validator state={serviceStatus === 'enable' && period ? maxDay : ''} rules="required|num" />
                      </div>
                    </>
                  }
                </div>
              </>
            }

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </>
    </ValidatorProvider>
  )
    ;
}